import * as z from 'zod';

export const roleFormSchema = z.object({
  name: z
    .string()
    .nonempty('Role name is required')
    .min(2, 'Role name must be at least 2 characters')
    .max(100, 'Role name cannot exceed 100 characters'),
  description: z
    .string()
    .nonempty('Description is required')
    .min(10, 'Description must be at least 10 characters')
    .max(255, 'Description cannot exceed 255 characters'),
  permissions: z.record(z.array(z.string())).default({}),
});

export type RoleFormData = z.infer<typeof roleFormSchema>;

